/*
 * Lead Profile Creation
 */

import React from "react";

import NewDealer from "./NewDealer";

interface defaultProps {}

const DealerPreAppointment = (props: any) => {
  const {
    header,
    selectedRow,
    onClose,
    isButtonDisabled,
    allStates,
    remarksList,
    getCrmRemarks,
    remarksLoading,
    setRemarksLoading,
    isApproved
  } = props;
  return (
    <>
      <NewDealer
        selectedRow={selectedRow}
        onClose={onClose}
        isButtonDisabled={isButtonDisabled}
        allStates={allStates}
        remarksList={remarksList}
        getCrmRemarks={getCrmRemarks}
        remarksLoading={remarksLoading}
        setRemarksLoading={setRemarksLoading}
        isApproved={isApproved}


      />
    </>
  );
};

export default DealerPreAppointment;
